import Icon from 'components/ui/Icon';
import styled from 'styled-components';
import {
  ADMIN_ICON_STANDARD,
} from 'style/mixins';

export default styled(Icon)`
  ${ADMIN_ICON_STANDARD}
`;
